const map = {
	"./49ers.png": 1858,
	"./Bears.png": 2152,
	"./Bengals.png": 7121,
	"./Bills.png": 3291,
	"./Broncos.png": 7417,
	"./Browns.png": 7166,
	"./Buccaneers.png": 8690,
	"./Cardinals.png": 8010,
	"./Chargers.png": 7712,
	"./Chiefs.png": 5035,
	"./Colts.png": 8796,
	"./Commanders.png": 400,
	"./Cowboys.png": 4673,
	"./Dolphins.png": 3074,
	"./Eagles.png": 5934,
	"./Falcons.png": 3447,
	"./Giants.png": 1587,
	"./Jaguars.png": 7116,
	"./Jets.png": 4465,
	"./Lions.png": 5548,
	"./Packers.png": 7048,
	"./Panthers.png": 7030,
	"./Patriots.png": 1053,
	"./Raiders.png": 5081,
	"./Rams.png": 8322,
	"./Ravens.png": 3912,
	"./Saints.png": 8103,
	"./Seahawks.png": 9688,
	"./Steelers.png": 8874,
	"./Texans.png": 1764,
	"./Titans.png": 1244,
	"./Vikings.png": 4484,
	"./egg.png": 2,
	"./egglogo.png": 175
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5126;